import { render, staticRenderFns } from "./TenderTotalsReport.vue?vue&type=template&id=27769284&"
import script from "./TenderTotalsReport.vue?vue&type=script&lang=js&"
export * from "./TenderTotalsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports